(function () {
    'use strict';

    /*
     UserResetPasswordController Module
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.resetPassword', [])

        /**
          * UserResetPasswordController for reset user password
          *
          * @inject __Form
          * @inject appServices
          * @inject __Utils
          * 
          * @return void
          *-------------------------------------------------------- */

        .controller('UserResetPasswordController', [
            '__Form',
            'appServices',
            '__Utils',
            function (__Form, appServices, __Utils) {

                var scope = this;

                scope = __Form.setup(scope, 'user_reset_password_form', 'userData', {
                    secured: true
                });

                /**
                  * Submit reset password form action
                  *
                  * @return void
                  *---------------------------------------------------------------- */

                scope.submit = function () {

                    __Form.process({
                        'apiURL': 'user.reset_password.process',
                        'reminderToken': __globals.getAppJSItem('passwordReminderToken')
                    }, scope)
                        .success(function (responseData) {

                            appServices.processResponse(responseData, null,
                                function (reactionCode) {
                                    window.location = __Utils.apiURL('user.login');
                                });

                        });

                };

            }
        ]);

})();